<template>
  <div>
    <h1 class="headline font-weight-bold main-title">のびしこがつくったサイト</h1>
    <!-- <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Vuetify</span>
        <span class="font-weight-light">MATERIAL DESIGN</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
        <span class="mr-2">Latest Release</span>
      </v-btn>
    </v-toolbar> -->
    <Works />
    <Author />
  </div>
</template>

<script>
  import Author from './components/Author'
  import Works from './components/Works'

  export default {
    name: 'App',
    components: {
      Author,
      Works
    },
    mounted() {
      this.$ga.page('/');
    },
    data() {
      return {
        //
      }
    }
  }
</script>
<style lang="scss">
  @import "src/assets/scss/style.scss";
</style>
<style scoped lang="scss">
  .main-title{
    text-align: center;
    // margin-top: 2.6rem;
    // margin-bottom: 2.6rem;
    margin: 0;
    border: 0;
    font-size: clamp(2.4rem, 4vw, 3.4rem);
    letter-spacing: 0.14em;
    // line-height: 1.15;
    position: relative;
    color: transparent;
    background: linear-gradient(90deg, #ff4d6d, #ffd166, #6ee7f9, #7c4dff);
    -webkit-background-clip: text;
    background-clip: text;
    // text-shadow: 0 2px 0 rgba(0, 0, 0, 0.12), 0 10px 20px rgba(0, 0, 0, 0.15);
  }

  .main-title::before{
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) ;
    width: 100vw;
    // max-width: 720px;
    height: 100%;
    background: linear-gradient(90deg, rgba(255, 77, 109, 0.2), rgba(255, 209, 102, 0.22), rgba(110, 231, 249, 0.22), rgba(124, 77, 255, 0.2));
    // border: 2px solid rgba(0, 0, 0, 0.08);
    // box-shadow: 0 8px 0 rgba(0, 0, 0, 0.06), 0 18px 30px rgba(0, 0, 0, 0.12);
    // border-radius: 999px;
    opacity: 0.6;
    z-index: -1;
  }

  // .main-title::after{
  //   content: "";
  //   display: block;
  //   width: 180px;
  //   height: 6px;
  //   margin: 0.7rem auto 0;
  //   background: linear-gradient(90deg, #ff4d6d, #ffd166, #6ee7f9, #7c4dff);
  //   border-radius: 999px;
  //   box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  // }
</style>



